import {
  WsEventsManager,
  WsRequestManager,
  WsSubscribeManager,
} from '@gem/modules/wsClient/wsManagers';

import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';

import { UntrustedWsAppApiController } from './UntrustedWsAppApiController';
import { untrustedWsAppApiNetworkService } from './UntrustedWsAppApiNetworkService';
import { UntrustedWsAppLog } from './UntrustedWsAppLog';

export const untrustedWsAppRequestManager = new WsRequestManager(untrustedWsAppApiNetworkService);

export const untrustedWsAppSubscribeManager = new WsSubscribeManager(
  untrustedWsAppApiNetworkService
);
export const untrustedWsAppEventsManager = new WsEventsManager(untrustedWsAppApiNetworkService);
export const untrustedWsAppLog = new UntrustedWsAppLog(untrustedWsAppApiNetworkService);

export const untrustedWsAppApiController = new UntrustedWsAppApiController(
  untrustedWsAppApiNetworkService,
  ProjectUrls.wsApiUrl
);
